export default __webpack_public_path__ + "static/media/add_phrase.bc8d4524.png";